import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import FormatCurrency from '../components/elements/FormatCurrency'
import FoodInCartSubmitted from './desktop/FoodInCartSubmitted'
import ListFoodWithGroup from './order/ListFoodWithGroup'

const ListFoodOrdered = ({ foods, total, shipMoney, discountAmount, voucherCode }) => {
    const { t } = useTranslation()

    const listGroupOrdered = useMemo(() => {
        if (!foods) {
            return []
        }

        const objectFoodGroup = foods.reduce(
            (groupObj, food) => ({
                ...groupObj,
                [food.groupOrder]: +food.groupOrder,
            }),
            {}
        )
        return Object.values(objectFoodGroup)
    }, [foods])

    if (!foods) {
        return null
    }


    return (
        <div className="mt-4 list-food-ordered">
            <ListFoodWithGroup
                isOrdered
                listFood={foods}
                renderFood={food => <FoodInCartSubmitted food={food} />}
                listGroupOrdered={listGroupOrdered}
                hideLabelGroup={listGroupOrdered.length === 1}
            />
            {!!shipMoney && (
                <div className="ship-money-ordered text-right">
                    {t('modalOrderSuccess.lbShippingPrice')}
                    <FormatCurrency amount={shipMoney} />
                </div>
            )}
            {!!discountAmount && (
                <div className="discount-ordered text-right">
                    {/* {voucherCode} */}
                    {t('modalOrderSuccess.lbDiscount')}:
                    <div />
                    <FormatCurrency amount={-discountAmount} />
                </div>
            )}
            <div className="total">
                <div
                    className="label-1 text-right"
                    style={{ paddingRight: '22px' }}
                >
                    <b>
                        {t('modalOrderSuccess.lbTotal')}:{' '}
                        <FormatCurrency
                            amount={total + (shipMoney || 0) - (discountAmount || 0)}
                        />
                    </b>
                </div>
            </div>
        </div>
    )
}

export default ListFoodOrdered
